import MuiSlider from '@mui/material/Slider';
import { styled } from '../../../../../../theme/styled';
import { CssTokensOfRange } from '../const';
import type { RangeInputSliderSize, RangeInputVariant } from '../model';

export type RangeInputSliderOwnerState = {
  variant: RangeInputVariant;
  sliderSize: RangeInputSliderSize;
};

export const Slider = styled(MuiSlider, {
  name: 'RangeInput',
  slot: 'Root',
})<{ ownerState: RangeInputSliderOwnerState }>(({ theme, ownerState }) => {
  if (ownerState.variant === 'minimal') {
    return {
      '&.MuiSlider-root': {
        color: theme.palette['brand pink'],
        height: 2,
        width: '100%',
        padding: '7px 0',
        boxSizing: 'content-box',
        position: 'relative',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
      },
      '& .MuiSlider-rail': {
        height: 2,
        opacity: 1,
        backgroundColor: theme.palette['gray light'],
      },
      '& .MuiSlider-track': {
        height: 2,
        borderWidth: 0,
      },
      '& .MuiSlider-thumb': {
        width: 16,
        height: 16,
        backgroundColor: theme.palette['brand pink'],
        border: `2px solid ${theme.palette.white}`,
        boxShadow: 'none',
        transition: 'background .2s ease-out',
        '&:hover, &.Mui-focusVisible, &.Mui-active': {
          boxShadow: 'none',
        },
      },
    };
  }

  return {
    '& .MuiSlider-valueLabelOpen': {
      backgroundColor: CssTokensOfRange.SliderLabelBackground('#757575'),
    },
    '&.MuiSlider-root': {
      color: theme.palette['brand pink'],
      height: CssTokensOfRange.SliderTrackHeight(),
      width: `calc(100% - ${CssTokensOfRange.SliderTrackHeight()} * 2)`,
      padding: '0',
      position: 'absolute',
      left: CssTokensOfRange.SliderTrackHeight(),
      right: CssTokensOfRange.SliderTrackHeight(),
      bottom: 0,
    },
    '& .MuiSlider-thumb': {
      height: CssTokensOfRange.SliderThumbSize(),
      width: CssTokensOfRange.SliderThumbSize(),
      backgroundColor: theme.palette['brand pink'],
      border: 'var(--range-slider-thumb-border-width, 2px) solid',
      borderColor: theme.palette.white,
      transition: 'background .3s ease-out',
      '& .Mui-disabled': {
        height: CssTokensOfRange.SliderThumbSize(),
        width: CssTokensOfRange.SliderThumbSize(),
        backgroundColor: theme.palette['gray light'],
        marginTop: `${CssTokensOfRange.SliderThumbSize()} / -2)`,
        marginLeft: `${CssTokensOfRange.SliderThumbSize()} / -2)`,
        border: `${CssTokensOfRange.SliderThumbBorderWidth()} solid`,
        borderColor: theme.palette.white,
      },
    },
    '& .MuiSlider-track': {
      height: CssTokensOfRange.SliderTrackHeight(),
      borderWidth: 0,
    },
    '& .MuiSlider-rail': {
      height: CssTokensOfRange.SliderTrackHeight(),
      opacity: 1,
      backgroundColor: theme.palette['gray light'],
    },
    '& .MuiSlider-mark': {
      backgroundColor: theme.palette.white,
      height: CssTokensOfRange.SliderTrackHeight(),
      width: CssTokensOfRange.SliderTrackHeight(),
      borderRadius: 'unset',
    },
    '& .MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: theme.palette.white,
    },
  };
});
